import { CheckCircleSolid, ExclamationCircleSolid, InformationCircleSolid } from "@medusajs/icons";
import { Toaster as Sonner, toast } from "sonner";
import { Spinner } from "./spinner";

/** Mount once near the root of an app. Raise messages with `toast.success("Saved")`. */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      gap={8}
      offset={16}
      mobileOffset={{ bottom: 16, left: 12, right: 12 }}
      icons={{
        success: <CheckCircleSolid className="text-ui-tag-green-icon" />,
        error: <ExclamationCircleSolid className="text-ui-tag-red-icon" />,
        warning: <ExclamationCircleSolid className="text-ui-tag-orange-icon" />,
        info: <InformationCircleSolid className="text-ui-fg-interactive" />,
        loading: <Spinner className="text-ui-fg-muted" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "flex w-full items-start gap-x-3 rounded-lg bg-ui-bg-base p-3 shadow-elevation-flyout sm:w-[356px]",
          icon: "mt-0.5 flex size-5 shrink-0 items-center justify-center",
          content: "flex flex-1 flex-col",
          title: "txt-compact-small-plus text-ui-fg-base",
          description: "txt-small text-ui-fg-subtle",
          actionButton:
            "txt-compact-small-plus shrink-0 cursor-pointer self-center rounded-md px-2 py-1 text-ui-fg-base shadow-buttons-neutral",
          cancelButton:
            "txt-compact-small-plus shrink-0 cursor-pointer self-center rounded-md px-2 py-1 text-ui-fg-subtle",
        },
      }}
    />
  );
}

export { toast };
